import React from 'react';
import {
  Text,
  HStack,
  Badge,
  Icon,
  Tooltip,
  Center,
} from '@wegroup/design-system';
import useFlowsHelper from '../../../../../hooks/useFlowsHelper';
import { useTranslation } from 'react-i18next';
import useCurrentGroups from '../../hooks/useCurrentGroups';
import useTagContent from '../../../common/hooks/useTagContent';

const CompanyScanBottomBarInfo: React.FC<
  React.PropsWithChildren<unknown>
> = () => {
  const { currentTag, getAnswersForGroup } = useFlowsHelper();
  const { t } = useTranslation();
  const groups = useCurrentGroups();
  const answeredGroupsAmount = groups.reduce((r, group) => {
    return (
      r +
      (getAnswersForGroup(group.id, group.index).length ===
      group.questions.length
        ? 1
        : 0)
    );
  }, 0);

  const tagContent = useTagContent(currentTag);

  return (
    <HStack justifySelf={{ base: 'flex-start', laptop: 'center' }}>
      <Text
        textStyle="smallBody"
        sx={{ '>span': { color: 'gray.300' } }}
        textAlign="center"
      >
        <span>
          {t('COMPANY-SCAN_QUESTION-FLOW_BOTTOM-BAR_CURRENT-SUBJECT')}:
        </span>{' '}
        {tagContent}
      </Text>
      <Tooltip
        label={t(
          'COMPANY-SCAN_QUESTION-FLOW_BOTTOM-BAR_TOOLTIP_NUMBER-OF-QUESTIONS',
        )}
      >
        <Badge
          bg="primary.50"
          textStyle="extraSmallBody"
          color="primary.500"
          boxShadow="level1"
        >
          {answeredGroupsAmount}/{groups.length}
        </Badge>
      </Tooltip>
      <Center>
        <Icon name="GeneralActionsChevronUpRounded" boxSize="4" />
      </Center>
    </HStack>
  );
};

export default CompanyScanBottomBarInfo;
